<template>
  <div data-testid="non-fbc-injector-nav" class="fc-top-nav non-fbc-injector-nav">
    <div
      v-if="showClientSwitcher || showNavActions"
      data-testid="non-fbc-injector-nav__cluster"
      class="fc-nav-actions non-fbc-injector-nav__cluster"
    >
      <!-- <div
        v-if="showClientSwitcher"
        data-testid="non-fbc-injector-nav__client-switcher"
        class="main-nav__client-switcher"
      >
        <client-selector
          :value="selectedClientId"
          :clients="clients"
          prepend-icon="mdi-domain"
          append-icon="mdi-chevron-down"
          @input="$emit('update:selectedClientId', $event)"
        />
      </div> -->

      <AskNoaButton
        v-if="showNavActions && chatbotEnabled"
        test-id="non-fbc-injector-nav__ask-noa"
        @click="openChatbot"
      />
    </div>
  </div>
</template>

<script>
import AskNoaButton from '../FinancialClose/AskNoaButton.vue';

export default {
  name: 'NonFbcInjectorNav',
  components: { AskNoaButton },
  props: {
    showClientSwitcher: { type: Boolean, default: false },
    showNavActions: { type: Boolean, default: false },
    selectedClientId: { type: String, default: '' },
    clients: { type: Array, default: () => [] },
    chatbotEnabled: { type: Boolean, default: false },
  },
  emits: ['update:selectedClientId', 'ask-noa'],
  methods: {
    openChatbot() {
      this.$emit('ask-noa');
      this.$root.toggleChatbot?.();
    },
  },
};
</script>

<style lang="scss">
@import '../FinancialClose/FinancialCloseTopNav.scss';
@import '../FinancialClose/FinancialCloseNavActions.scss';
@import './NonFbcInjectorNav.scss';
</style>
